/* Menahub availability sorter (v1.0.6.5)
   Moves sold-out items after available items within each product grid.
*/
(function () {
  function sortParent(parent) {
    if (!parent) return;
    var items = Array.prototype.slice.call(parent.children).filter(function(el){
      return el && el.getAttribute && el.getAttribute('data-available') !== null;
    });
    if (items.length < 2) return;

    items.sort(function(a, b){
      var av = parseInt(a.getAttribute('data-available') || '1', 10);
      var bv = parseInt(b.getAttribute('data-available') || '1', 10);
      return bv - av; // available(1) first
    });

    items.forEach(function(el){ parent.appendChild(el); });
  }

  function run() {
    // Approach: group items by their immediate parent and sort that parent.
    var parents = new Set();
    document.querySelectorAll('[data-available]').forEach(function(el){
      if (el.parentElement) parents.add(el.parentElement);
    });
    parents.forEach(function(p){ sortParent(p); });
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
